// Animation primitive registry — DECISION-024.
//
// Each primitive registers itself at module import. The composer looks
// up the primitive by name from `manifest.animations[*].kind` and calls
// its `start` function once per fixture instance.

const _registry = new Map();

/**
 * @typedef {Object} AnimationContext
 * @property {Object} anchor          Anchor entry.
 * @property {Object} manifest        Full fixture manifest.
 * @property {Object} animationDef    The single manifest.animations[N] entry being started.
 * @property {Object} bodyMesh        Placed body mesh (typical animation target).
 * @property {Object} stage           Runtime Stage instance — primitive uses stage's update loop hook.
 */

/**
 * Register an animation primitive.
 * @param {string} name
 * @param {(ctx: AnimationContext) => (() => void) | void} startFn
 *   Returns an optional stop function called on fixture teardown.
 */
export function registerAnimation(name, startFn) {
	if (_registry.has(name)) {
		console.warn(`[animations] '${name}' already registered; overwriting`);
	}
	_registry.set(name, startFn);
}

export function getAnimation(name) {
	return _registry.get(name) || null;
}

export function listAnimations() {
	return Array.from(_registry.keys());
}
